module.exports = __webpack_public_path__ + "img/logoLorfolioPro.67ec3f3a.svg";